import html2pdf from 'html2pdf.js'; // Import html2pdf library
import { formatedDate } from '../Functions/convertDate';
import { formatedNumber } from '../Functions/convertNumber';

export const saveFacturePDF = (facture) => {
  const { consommations, clients, logements } = facture[0];

  const generateRowsHTML = (rows, formatter) => rows.map(formatter).join('');

  const clientRowFormatter = (client) => `
    <tr>
      <td class="td-x-large handlePrint__td">${client.passport}</td>
      <td class="handlePrint__td">${client.clientName}</td>
      <td class="td-large handlePrint__td">${new Date(client.clientCheckIn).toLocaleDateString()}</td>
      <td class="td-large handlePrint__td">${new Date(client.clientCheckOut).toLocaleDateString()}</td>
    </tr>`;
  
  const clientRowsHTML = generateRowsHTML(clients, clientRowFormatter);
  
  const consommationRowFormatter = (consommation) => `
    <tr>
      <td class="td-x-large handlePrint__td">${new Date(consommation.enterDate).toLocaleDateString()}</td>
      <td class="td-x-large handlePrint__td">${new Date(consommation.sortDate).toLocaleDateString()}</td>
      <td class="handlePrint__td">${consommation.description}</td>
      <td class="td-small handlePrint__td">${formatedNumber(consommation.unitPrice)}</td>
      <td class="td-smallest1 handlePrint__td">${consommation.quantiteConsom}</td>
      <td class="td-large handlePrint__td">${formatedNumber(consommation.totalConsom)}</td>
    </tr>`;
  
  const consommationRowsHTML = generateRowsHTML(consommations, consommationRowFormatter);
  
  const logementRowFormatter = (logement) => `
    <tr>
      <td class="handlePrint__td">${logement.typeChambre}</td>
      <td class="handlePrint__td">${logement.pension}</td>
      <td class="td-small handlePrint__td">${logement.checkIn ? new Date(logement.checkIn).toLocaleDateString() : ''}</td>
      <td class="td-small handlePrint__td">${logement.checkOut ? new Date(logement.checkOut).toLocaleDateString() : ''}</td>
      <td class="td-small handlePrint__td">${formatedNumber(logement.prixChambre)}</td>
      <td class="td-smallest handlePrint__td">${logement.quantite}</td>
      <td class="td-large handlePrint__td">${formatedNumber(logement.totalLoge)}</td>
    </tr>`;
  
  const logementRowsHTML = generateRowsHTML(logements, logementRowFormatter);


  const styles = `
    .handlePrint__body { font-family: Arial, sans-serif; margin: 20px; direction: rtl; }
    .handlePrint__body h1 { margin-bottom: 10px; margin-top: 90px; }
    .handlePrint__body h2 { margin-bottom: 10px; }
    .handlePrint__table { width: 100%; border-collapse: collapse; margin: 10px 0; }
    .handlePrint__td { border: 1px solid #000000; padding: 3px; text-align: right; }
    .handlePrint__body th { background-color: #c4c4c4; font-weight: bold; }
    .summary-table { 
      width: 50%; 
      float: left; /* Align the table to the right */
      margin-right: auto; /* Push it to the right margin */
      margin-left: 0; /* Ensure there's no space on the right */
      padding-bottom: 0;
      margin-bottom: 0;
    }

    .background_color{ background-color: #c4c4c4 }

    .summary-table-2 { 
      width: 65%; 
      float: left; /* Align the table to the right */
      margin-right: auto; /* Push it to the right margin */
      margin-left: 0; /* Ensure there's no space on the right */
      padding-top: 0;
      margin-top: 0;
    }

    .bold { font-weight: bold; }
    .large { font-size: 2.2em; }
    .center { text-align: center;}
    .bold-border { border: 2px solid #000000; }
    .Bold-border-top { border-top: 2px solid #000000; /* 2px solid on top */ }
    .Bold-border-bottom { border-bottom: 2px solid #000000; /* 2px solid on top */ }
    .Bold-border-left { border-left: 2px solid #000000; /* 2px solid on top */ }
    .Bold-border-right { border-right: 2px solid #000000; /* 2px solid on top */ }
    .line-width { width: 100px }
    .line-width-large { width: 100% }

    .td-smallest{width: 3%;}
    .td-smallest1{width: 2%;}
    .td-small{width: 13%;}
    .td-middle{width: 15%;}
    .td-large{width: 16%;}
    .td-x-large{width: 20%;}
    .td-xl-large{width: 24%;}
    .td-xx-large{width: 31%;}
  `;
  
  const element = document.createElement('div');
  element.innerHTML = `
    <html>
      <head>
        <title>فاتورة</title>
        <style>
         ${styles}
        </style>
      </head>
      <body>
        <div class="handlePrint__body">
          <h1>فاتورة</h1>
          <table class="handlePrint__uniq-table handlePrint__table">
            <tr>
              <td class="td-x-large Bold-border-top Bold-border-right handlePrint__td">رقم الفاتورة</td>
              <td class="td-small Bold-border-top handlePrint__td">${facture[0].id_facture}</td>
              <td rowspan="3" class="handlePrint__td bold large center Bold-border-left Bold-border-top Bold-border-bottom">${facture[0].selectedorganisme}</td>
            </tr>
            <tr>
              <td class="Bold-border-right handlePrint__td">${facture[0].selectedHotel}</td>
              <td class="handlePrint__td">${facture[0].nbrfact}</td>
            </tr>
            <tr>
              <td class="Bold-border-bottom Bold-border-right handlePrint__td">التاريخ</td>
              <td class="Bold-border-bottom handlePrint__td">${formatedDate(facture[0].currentDate)}</td>
            </tr>
          </table>
          <h2>الحرفاء</h2>
          <table class="handlePrint__table">
            <thead>
              <tr>
                <th class="handlePrint__td">رقم جواز السفر</th>
                <th class="handlePrint__td">اسم الحريف</th>
                <th class="handlePrint__td">تاريخ الدخول</th>
                <th class="handlePrint__td">تاريخ المغادرة</th>
              </tr>
            </thead>
            <tbody>${clientRowsHTML}</tbody>
          </table>
          <h2>الإقامة</h2>
          <table class="handlePrint__table">
            <thead>
              <tr>
                <th class="handlePrint__td">نوع الغرفة</th>
                <th class="handlePrint__td">نوع الإقامة</th>
                <th class="handlePrint__td">تاريخ الدخول</th>
                <th class="handlePrint__td">تاريخ المغادرة</th>
                <th class="handlePrint__td">السعر الفردي</th>
                <th class="handlePrint__td">الكمية</th>
                <th class="handlePrint__td">المجموع</th>
              </tr>
            </thead>
            <tbody>${logementRowsHTML}</tbody>
          </table>
          <h2>الإضافات</h2>
          <table class="handlePrint__table">
            <thead>
              <tr>
                <th class="handlePrint__td">تاريخ الدخول</th>
                <th class="handlePrint__td">تاريخ المغادرة</th>
                <th class="handlePrint__td">الوصف</th>
                <th class="handlePrint__td">السعر الفردي</th>
                <th class="handlePrint__td">الكمية</th>
                <th class="handlePrint__td">المجموع</th>
              </tr>
            </thead>
            <tbody>${consommationRowsHTML}</tbody>
          </table>
          <table class="summary-table handlePrint__table">
            <tr class="handlePrint__td bold background_color"><td class="Bold-border-top Bold-border-right">المجموع</td><td class="handlePrint__td td-xx-large Bold-border-top Bold-border-left">${formatedNumber(facture[0].totalFacture)}</td></tr>
            <tr><td class="handlePrint__td Bold-border-right">عمولة 20%</td><td class="Bold-border-left handlePrint__td">${formatedNumber(facture[0].commission)}</td></tr>
            <tr><td class="handlePrint__td Bold-border-right">القيمة المضافة على العمولة 19 %</td><td class="handlePrint__td Bold-border-left">${formatedNumber(facture[0].comtax)}</td></tr>
            <tr><td class="handlePrint__td Bold-border-right">ظريبة الاقامة</td><td class="handlePrint__td Bold-border-left">${formatedNumber(facture[0].tva)}</td></tr>
            <tr><td class="handlePrint__td Bold-border-right">الطابع الجبائي</td><td class="handlePrint__td Bold-border-left">${formatedNumber(facture[0].timbre)}</td></tr>
          </table>
          <table class="summary-table-2 handlePrint__table">
             <tr class="bold Bold-border background_color"><td class="center handlePrint__td">المبلغ المطلوب</td><td class="td-xl-large handlePrint__td">${formatedNumber(facture[0].solde)}</td></tr>
          </table>
        </div>
      </body>
    </html>`;

  // Create a hidden container for the element
  const container = document.createElement('div');
  container.style.display = 'none'; // Make it hidden
  container.appendChild(element);
  document.body.appendChild(container);

  // Use html2pdf to generate the PDF
  html2pdf()
    .from(element)
    .save(`facture_${facture[0].id_facture}.pdf`)
    .then(() => {
      document.body.removeChild(container); // Remove the hidden container after PDF is generated
    });
};
